import type { ApolloClient } from '@apollo/client';
import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import useAbortRegistry from '@dr-pam/common-components/Hooks/useAbortRegistry';
import ApolloUtils from '@dr-pam/common-components/Utils/ApolloUtils';
import type { RegisterAbortFunction } from '@dr-pam/common-components/Utils/AbortUtils';
import { useMemo } from 'react';

export const GQL_GET_TAGS = gql`
	query Tags {
		tags(orderBy: { name: asc }) {
			id
			name
		}
	}
`;

export type TagListItem = {
	id: string;
	name: string;
};

type TagsQuery = {
	tags: TagListItem[];
};

export default class TagService {
	constructor(
		private readonly _apolloClient: ApolloClient,
		private readonly _registerAbort?: RegisterAbortFunction,
	) {}

	public getAll() {
		return ApolloUtils.abortableQuery<TagsQuery, TagListItem[]>(
			this._apolloClient,
			{
				query: GQL_GET_TAGS,
			},
			(data) => data.tags,
			this._registerAbort,
		);
	}
}

export function useTagService() {
	const apolloClient = useApolloClient();
	const registerAbort = useAbortRegistry();

	return useMemo(() => new TagService(apolloClient, registerAbort), [apolloClient, registerAbort]);
}
